<template>
  <v-layout align-center align-baseline justify-center>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="facturas"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Facturas</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  icon
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  @click="listar()"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Actualizar</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-menu
              v-if="verNuevo == 0"
              v-model="menuFechas"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Opciones</v-btn
                >
              </template>
              <v-card>
                <v-list>
                  <v-list-item>
                    <v-text-field
                      v-model="fechaInicio"
                      hide-details
                      type="date"
                      label="Desde"
                      :max="new Date().toISOString().substr(0, 10)"
                      clearable
                    ></v-text-field>
                  </v-list-item>

                  <v-list-item>
                    <v-text-field
                      v-model="fechaFin"
                      hide-details
                      type="date"
                      label="Hasta"
                      :max="new Date().toISOString().substr(0, 10)"
                      clearable
                    ></v-text-field>
                  </v-list-item>
                  <v-list-item>
                    <v-btn color="primary" dark @click="filtrarFacturas()"
                      >Filtrar</v-btn
                    >
                    <v-btn
                      color="green"
                      dark
                      class="mx-2"
                      @click="generarObjetoExcel()"
                      >Descargar</v-btn
                    >
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <v-btn v-if="verNuevo == 0" color="primary" @click="abrirNuevo()"
              >Nuevo</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)"> tab </v-icon>
        </template>
      </v-data-table>

      <v-overlay v-model="overlay" z-index="1">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackError" color="cyan darken-2" top
        >SUCEDIO ALGUN ERROR, VERIFICAR ESTADO DE CONEXIÓN, Y VUELVA A
        INTENTAR.</v-snackbar
      >

      <v-row v-if="verNuevo == 1">
        <v-col cols="12" class="pa-0">
          <v-toolbar>
            <v-checkbox
              v-model="banderaCuadricula"
              @change="habilitarCuadricula()"
              label="Habilitar cuadricula"
              hint="Al imprimir deshabilitar la cuadricula"
              persistent-hint
              class="ml-5"
            ></v-checkbox>
            <v-checkbox
              v-model="banderaTitulos"
              @change="habilitarTitulos()"
              label="Habilitar títulos"
              hint="Al imprimir deshabilitar los titulos"
              persistent-hint
              class="ml-5"
            ></v-checkbox>
            <v-checkbox
              v-model="es_uno_porciento"
              label="Hacer cálclo de 1%"
              hint="Validación para calculo de 1%"
              persistent-hint
              class="ml-5"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-autocomplete
              v-model="nombreClienteItem"
              :items="items"
              item-text="nombre"
              return-object
              label="Nombre de cliente"
              @change="verCliente()"
              :loading="nombreClienteItem.length < 0"
              hide-details
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              rounded
              color="grey"
              @click="cerrarNuevo()"
              class="ml-5"
              >Cancelar</v-btn
            >
            <v-btn
              outlined
              rounded
              color="blue"
              @click="guardar()"
              v-if="verDet == 0"
              class="ml-5"
              >Guardar</v-btn
            >
            <v-btn
              outlined
              rounded
              color="blue"
              @click="actualizar()"
              v-if="verDet == 1"
              class="ml-5"
              >Actualizar</v-btn
            >
            <v-btn
              outlined
              rounded
              color="blue"
              @click="imprimir()"
              class="ml-5"
              >Imprimir</v-btn
            >
          </v-toolbar>
        </v-col>
        <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="F1"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="792px"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
          class="mx-auto"
        >
          <section slot="pdf-content">
            <v-col cols="12">
              <!-- CAMPO VACIO -->
              <v-card
                max-width="800"
                height="120"
                elevation="0"
                style="margin-left: 25px; margin-right: 25px; margin-top: 56px"
              >
                <v-row no-gutters justify="end">
                  <v-col cols="auto" class="textStyle mt-12">
                    <div class="mt-2">No</div>
                  </v-col>
                  <v-col cols="1" class="mt-12">
                    <v-text-field
                      hide-details
                      class="some-style styleText"
                      dense
                      v-model="numeroFactura"
                      v-if="correlativo"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <!-- FECHA -->
              <v-card max-width="792" height="auto" elevation="0">
                <v-row
                  no-gutters
                  style="
                    justify-content: right;
                    padding-left: 25px;
                    padding-right: 25px;
                    margin-top: 0px;
                  "
                >
                  <v-col
                    cols="3"
                    style="
                      padding-left: 0px;
                      padding-top: 0px;
                      margin-right: 10px;
                      padding-right: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      class="some-style styleText"
                      dense
                      v-model="fecha"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <!-- DATOS PRINCIPALES -->
              <v-card max-width="792" height="auto" elevation="0">
                <v-row style="margin: 0px" no-gutters>
                  <v-col cols="auto" class="textStyle">
                    <div>Cliente</div>
                  </v-col>
                  <v-col
                    cols="10"
                    style="
                      padding-left: 58px;
                      padding-top: 0px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="cliente"
                      class="some-style styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row style="margin: 0px" no-gutters>
                  <v-col cols="auto" class="textStyle">
                    <div>Dirección</div>
                  </v-col>
                  <v-col
                    cols="10"
                    style="
                      padding-left: 50px;
                      padding-top: 5px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="direccion"
                      class="some-style styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row style="margin: 0px" no-gutters>
                  <v-col cols="auto" class="textStyle">
                    <div>Departamento</div>
                  </v-col>
                  <v-col
                    cols="3"
                    style="
                      padding-left: 44px;
                      padding-right: 0px;
                      padding-top: 5px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="departamento"
                      class="some-style styleText"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="paddingText">
                    <div class="textStyle">NIT</div>
                  </v-col>
                  <v-col
                    cols="3"
                    style="
                      padding-left: 19px;
                      padding-right: 0px;
                      padding-top: 5px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="nit"
                      class="some-style styleText"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="paddingText">
                    <div class="textStyle">N.C.R</div>
                  </v-col>
                  <v-col
                    cols="2"
                    style="
                      padding-left: 0px;
                      padding-top: 5px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                      margin-bottom: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="ncr"
                      class="some-style styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row style="margin: 0px" no-gutters>
                  <v-col cols="auto" class="textStyle">
                    <div>Giro</div>
                  </v-col>
                  <v-col
                    cols="5"
                    style="
                      padding-left: 59px;
                      padding-top: 5px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="giro"
                      class="some-style styleText pl-3"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="auto"
                    class="textStyle"
                    style="padding-left: 0px"
                  >
                    <div>Forma de pago</div>
                  </v-col>
                  <v-col
                    cols="auto"
                    style="
                      padding-left: 28px;
                      padding-top: 5px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="formaPago"
                      class="some-style styleText pl-8"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <!-- DATOS DE TABLA -->
              <v-card
                max-width="792"
                height="417"
                elevation="0"
                style="
                  padding-left: 0px;
                  padding-top: 0px;
                  padding-bottom: 0px;
                  margin-top: 40px;
                  margin-left: 35px;
                  margin-right: 42px;
                "
              >
                <table style="border-collapse: collapse">
                  <tr style="height: 45px; padding-top: 8px">
                    <th style="width: 8%" class="textStyleTabla1">cant.</th>
                    <th
                      style="width: 56%; padding-right: 4px"
                      class="textStyleTabla1"
                    >
                      descripcion
                    </th>
                    <th
                      style="width: 8%; padding-right: 4px"
                      class="textStyleTabla1"
                    >
                      precio unitario
                    </th>
                    <th
                      style="width: 8%; padding-right: 4px"
                      class="textStyleTabla1"
                    >
                      ventas sujetas
                    </th>
                    <th
                      style="width: 7%; padding-right: 4px"
                      class="textStyleTabla1"
                    >
                      ventas exentas
                    </th>
                    <th class="textStyleTabla1">ventas afectas</th>
                  </tr>
                  <tr>
                    <td style="text-align: center">
                      <div
                        id="cant1"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText-cant"
                      >
                        {{ cant_1 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc1"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        @input="limitCharacters"
                        class="styleText-cant"
                      >
                        {{ descripcion_1 }}
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div
                        id="pu1"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText-cant"
                      >
                        {{ precioUnitario_1 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="vs1"
                        contenteditable="true"
                        @blur="cadenaVS()"
                        class="styleText"
                      >
                        {{ ventasSujetas_1 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="ve1"
                        contenteditable="true"
                        @blur="cadenaVE()"
                        class="styleText"
                      >
                        {{ ventasExcentas_1 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="va1"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ ventasAfectas_1 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center">
                      <div
                        id="cant2"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText-cant"
                      >
                        {{ cant_2 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc2"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        @input="limitCharacters"
                        class="styleText-cant"
                      >
                        {{ descripcion_2 }}
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div
                        id="pu2"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText-cant"
                      >
                        {{ precioUnitario_2 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="vs2"
                        contenteditable="true"
                        @blur="cadenaVS()"
                        class="styleText"
                      >
                        {{ ventasSujetas_2 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="ve2"
                        contenteditable="true"
                        @blur="cadenaVE()"
                        class="styleText"
                      >
                        {{ ventasExcentas_2 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="va2"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ ventasAfectas_2 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: right">
                      <div
                        id="cant3"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText-cant"
                      >
                        {{ cant_3 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc3"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        @input="limitCharacters"
                        class="styleText-cant"
                      >
                        {{ descripcion_3 }}
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div
                        id="pu3"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText-cant"
                      >
                        {{ precioUnitario_3 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="vs3"
                        contenteditable="true"
                        @blur="cadenaVS()"
                        class="styleText"
                      >
                        {{ ventasSujetas_3 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="ve3"
                        contenteditable="true"
                        @blur="cadenaVE()"
                        class="styleText"
                      >
                        {{ ventasExcentas_3 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="va3"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ ventasAfectas_3 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: right">
                      <div
                        id="cant4"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText-cant"
                      >
                        {{ cant_4 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc4"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        @input="limitCharacters"
                        class="styleText-cant"
                      >
                        {{ descripcion_4 }}
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div
                        id="pu4"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText-cant"
                      >
                        {{ precioUnitario_4 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="vs4"
                        contenteditable="true"
                        @blur="cadenaVS()"
                        class="styleText"
                      >
                        {{ ventasSujetas_4 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="ve4"
                        contenteditable="true"
                        @blur="cadenaVE()"
                        class="styleText"
                      >
                        {{ ventasExcentas_4 }}
                      </div>
                    </td>
                    <td style="text-align: right">
                      <div
                        id="va4"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ ventasAfectas_4 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: right">
                      <div
                        id="cant5"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText-cant"
                      >
                        {{ cant_5 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc5"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        @input="limitCharacters"
                        class="styleText-cant"
                      >
                        {{ descripcion_5 }}
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div
                        id="pu5"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText-cant"
                      >
                        {{ precioUnitario_5 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="vs5"
                        contenteditable="true"
                        @blur="cadenaVS()"
                        class="styleText"
                      >
                        {{ ventasSujetas_5 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="ve5"
                        contenteditable="true"
                        @blur="cadenaVE()"
                        class="styleText"
                      >
                        {{ ventasExcentas_5 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="va5"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ ventasAfectas_5 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        id="cant6"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText-cant"
                      >
                        {{ cant_6 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc6"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        @input="limitCharacters"
                        class="styleText-cant"
                      >
                        {{ descripcion_6 }}
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div
                        id="pu6"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText-cant"
                      >
                        {{ precioUnitario_6 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="vs6"
                        contenteditable="true"
                        @blur="cadenaVS()"
                        class="styleText"
                      >
                        {{ ventasSujetas_6 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="ve6"
                        contenteditable="true"
                        @blur="cadenaVE()"
                        class="styleText"
                      >
                        {{ ventasExcentas_6 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="va6"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ ventasAfectas_6 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        id="cant7"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText-cant"
                      >
                        {{ cant_7 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc7"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        @input="limitCharacters"
                        class="styleText-cant"
                      >
                        {{ descripcion_7 }}
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div
                        id="pu7"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText-cant"
                      >
                        {{ precioUnitario_7 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="vs7"
                        contenteditable="true"
                        @blur="cadenaVS()"
                        class="styleText"
                      >
                        {{ ventasSujetas_7 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="ve7"
                        contenteditable="true"
                        @blur="cadenaVE()"
                        class="styleText"
                      >
                        {{ ventasExcentas_7 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="va7"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ ventasAfectas_7 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        id="cant8"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText-cant"
                      >
                        {{ cant_8 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc8"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        @input="limitCharacters"
                        class="styleText-cant"
                      >
                        {{ descripcion_8 }}
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div
                        id="pu8"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText-cant"
                      >
                        {{ precioUnitario_8 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="vs8"
                        contenteditable="true"
                        @blur="cadenaVS()"
                        class="styleText"
                      >
                        {{ ventasSujetas_8 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="ve8"
                        contenteditable="true"
                        @blur="cadenaVE()"
                        class="styleText"
                      >
                        {{ ventasExcentas_8 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="va8"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ ventasAfectas_8 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        id="cant9"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText-cant"
                      >
                        {{ cant_9 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc9"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        class="styleText-cant"
                        @input="limitCharacters"
                      >
                        {{ descripcion_9 }}
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div
                        id="pu9"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText-cant"
                      >
                        {{ precioUnitario_9 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="vs9"
                        contenteditable="true"
                        @blur="cadenaVS()"
                        class="styleText"
                      >
                        {{ ventasSujetas_9 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="ve9"
                        contenteditable="true"
                        @blur="cadenaVE()"
                        class="styleText"
                      >
                        {{ ventasExcentas_9 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="va9"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ ventasAfectas_9 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        id="cant10"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText-cant"
                      >
                        {{ cant_10 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc10"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        @input="limitCharacters"
                        class="styleText-cant"
                      >
                        {{ descripcion_10 }}
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div
                        id="pu10"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText-cant"
                      >
                        {{ precioUnitario_10 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="vs10"
                        contenteditable="true"
                        @blur="cadenaVS()"
                        class="styleText"
                      >
                        {{ ventasSujetas_10 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="ve10"
                        contenteditable="true"
                        @blur="cadenaVE()"
                        class="styleText"
                      >
                        {{ ventasExcentas_10 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="va10"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ ventasAfectas_10 }}
                      </div>
                    </td>
                  </tr>
                </table>
              </v-card>

              <!-- DATOS FOOTER -->
              <v-card
                max-width="792"
                height="177"
                elevation="0"
                style="
                  padding-left: 0px;
                  padding-bottom: 0px;
                  margin-top: 0px;
                  margin-left: 40px;
                  margin-right: 42px;
                "
              >
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <div
                          style="
                            height: 73px;
                            padding-top: 34px;
                            padding-left: 25px;
                            padding-right: 0px;
                          "
                          contenteditable="true"
                          class="styleText"
                        >
                          {{ cantidadLetras }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="5"
                    style="background-color: white; margin-top: 16px"
                  >
                    <table style="border-collapse: collapse">
                      <tr style="height: 25px">
                        <th style="width: 90%" class="textStyleTabla1">
                          sumas
                        </th>
                        <th style="width: 50%">
                          <div
                            id="sumas"
                            contenteditable="true"
                            class="styleText"
                            style="text-align: right"
                          >
                            {{ sumas }}
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <td style="height: 25px">
                          <div contenteditable="true" class="textStyleTabla1">
                            IVA
                          </div>
                        </td>
                        <td>
                          <div
                            id="iva"
                            contenteditable="true"
                            class="styleText"
                            style="text-align: right"
                          >
                            {{ iva }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="height: 25px">
                          <div contenteditable="true" class="textStyleTabla1">
                            Sub-Total
                          </div>
                        </td>
                        <td>
                          <div
                            id="subTotal"
                            contenteditable="true"
                            class="styleText"
                            style="text-align: right"
                          >
                            {{ subTotal }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="height: 25px">
                          <div contenteditable="true" class="textStyleTabla1">
                            (-1%) IVA Retenido
                          </div>
                        </td>
                        <td>
                          <div
                            id="ivaRetenido"
                            contenteditable="true"
                            class="styleText"
                            style="text-align: right"
                          >
                            {{ ivaRetenido }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="height: 22px">
                          <div contenteditable="true" class="textStyleTabla1">
                            Venta no sujeta
                          </div>
                        </td>
                        <td>
                          <div
                            id="ventaNoSujeta"
                            contenteditable="true"
                            class="styleText"
                            style="text-align: right"
                          >
                            {{ ventaNoSujeta }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="height: 24px">
                          <div contenteditable="true" class="textStyleTabla1">
                            Ventas exentas
                          </div>
                        </td>
                        <td>
                          <div
                            id="ventasExentas"
                            contenteditable="true"
                            class="styleText"
                            style="text-align: right"
                          >
                            {{ ventasExentas }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="height: 25px">
                          <div contenteditable="true" class="textStyleTabla1">
                            Total
                          </div>
                        </td>
                        <td>
                          <div
                            id="total"
                            contenteditable="true"
                            @blur="conversionNumero()"
                            class="styleText"
                            style="text-align: right"
                          >
                            {{ montoDolares }}
                          </div>
                        </td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </section>
        </vue-html2pdf>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import XLSX from "xlsx";
export default {
  data() {
    return {
      facturas: [],
      items: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Fecha creación",
          value: "fechaCreacion",
          align: "left",
        },
        {
          text: "Fecha",
          value: "fecha",
          align: "left",
        },
        {
          text: "Cliente",
          value: "cliente",
          align: "left",
        },
        {
          text: "Dirección",
          value: "direccion",
          align: "left",
        },
        {
          text: "Departamento",
          value: "departamento",
          align: "left",
        },
        {
          text: "Nit",
          value: "nit",
          align: "left",
        },
        {
          text: "N.C.R",
          value: "ncr",
          align: "left",
        },
        {
          text: "Giro",
          value: "giro",
          align: "left",
        },
        {
          text: "Forma de pago",
          value: "formaPago",
          align: "left",
        },
        {
          text: "Sumas",
          value: "sumas",
          align: "left",
        },
      ],
      search: "",
      verNuevo: 0,
      verDet: 0,
      nombreClienteItem: "",
      correlativo: true,
      numeroFactura: "***",
      menuFechas: false,
      fechaInicio: "",
      fechaFin: "",
      overlay: false,
      snackError: false,
      idFactura: 0,
      idUsuario: 0,
      idBaseClienteFactura: 0,
      fechaCreacion: "",
      fecha: "Fecha",
      cliente: "***",
      direccion: "***",
      departamento: "***",
      giro: "***",
      nit: "***",
      ncr: "***",
      formaPago: "***",
      banderaCuadricula: true,
      banderaTitulos: true,
      cadenaCantidad: "",
      cant_1: "",
      cant_2: "",
      cant_3: "",
      cant_4: "",
      cant_5: "",
      cant_6: "",
      cant_7: "",
      cant_8: "",
      cant_9: "",
      cant_10: "",
      cadenaDescripcion: "",
      descripcion_1: "",
      descripcion_2: "",
      descripcion_3: "",
      descripcion_4: "",
      descripcion_5: "",
      descripcion_6: "",
      descripcion_7: "",
      descripcion_8: "",
      descripcion_9: "",
      descripcion_10: "",
      cadenaPrecioUnitario: "",
      precioUnitario_1: "",
      precioUnitario_2: "",
      precioUnitario_3: "",
      precioUnitario_4: "",
      precioUnitario_5: "",
      precioUnitario_6: "",
      precioUnitario_7: "",
      precioUnitario_8: "",
      precioUnitario_9: "",
      precioUnitario_10: "",
      cadenaVentasSujetas: "",
      ventasSujetas_1: "",
      ventasSujetas_2: "",
      ventasSujetas_3: "",
      ventasSujetas_4: "",
      ventasSujetas_5: "",
      ventasSujetas_6: "",
      ventasSujetas_7: "",
      ventasSujetas_8: "",
      ventasSujetas_9: "",
      ventasSujetas_10: "",
      cadenaVentasExentas: "",
      ventasExcentas_1: "",
      ventasExcentas_2: "",
      ventasExcentas_3: "",
      ventasExcentas_4: "",
      ventasExcentas_5: "",
      ventasExcentas_6: "",
      ventasExcentas_7: "",
      ventasExcentas_8: "",
      ventasExcentas_9: "",
      ventasExcentas_10: "",
      cadenaVentasAfectas: "",
      ventasAfectas_1: "",
      ventasAfectas_2: "",
      ventasAfectas_3: "",
      ventasAfectas_4: "",
      ventasAfectas_5: "",
      ventasAfectas_6: "",
      ventasAfectas_7: "",
      ventasAfectas_8: "",
      ventasAfectas_9: "",
      ventasAfectas_10: "",
      sumas: 0,
      iva: 0,
      subTotal: 0,
      ventaNoSujeta: 0,
      ventasExentas: 0,
      ivaRetenido: 0,
      montoDolares: 0,
      cantidadLetras: "",
      exportData: [],
      es_uno_porciento: false,
    };
  },
  components: {
    VueHtml2pdf,
  },
  created() {
    this.listar();
  },
  methods: {
    limitCharacters(event) {
      const element = event.target;
      const content = element.textContent;

      if (content.length > 40) {
        const truncatedContent = content.slice(0, 40);
        if (element.textContent !== truncatedContent) {
          element.textContent = truncatedContent;

          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(element);
          range.collapse(false);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    },
    abrirNuevo() {
      this.verNuevo = 1;
      this.verDet = 0;
      this.correlativo = true;
      var today = new Date();
      this.fechaCreacion =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();

      this.obtenerClientes();
    },
    cerrarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    listar() {
      let me = this;
      me.contadorID = 0;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.facturas = [];
      me.overlay = true;
      axios
        .get("api/FormFacturas/Listar", configuracion)
        .then(function (response) {
          me.overlay = false;
          me.facturas = response.data;
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    obtenerClientes() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/BaseClientesFacturas/Listar", configuracion)
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    verCliente() {
      this.idBaseClienteFactura = this.nombreClienteItem.idBaseClienteFactura;
      this.cliente = this.nombreClienteItem.nombre;
      this.direccion = this.nombreClienteItem.direccion;
      this.departamento = this.nombreClienteItem.departamento;
      this.nit = this.nombreClienteItem.nit;
      this.ncr = this.nombreClienteItem.ncr;
      this.giro = this.nombreClienteItem.giro;
    },
    filtrarFacturas() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.facturas = [];
      me.overlay = true;
      axios
        .get(
          "api/FormFacturas/FiltrarFacturas/" +
            me.fechaInicio +
            "/" +
            me.fechaFin,
          configuracion
        )
        .then(function (response) {
          me.overlay = false;
          me.facturas = response.data;
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    verDetalles(item) {
      this.obtenerClientes();
      this.numeroFactura = item.numeroFactura;
      this.idFactura = item.idFactura;
      this.idUsuario = item.idUsuario;
      this.idBaseClienteFactura = item.idBaseClienteFactura;
      this.fechaCreacion = item.fechaCreacion;
      this.fecha = item.fecha;
      this.cliente = item.cliente;
      this.direccion = item.direccion;
      this.departamento = item.departamento;
      this.nit = item.nit;
      this.ncr = item.ncr;
      this.giro = item.giro;
      this.formaPago = item.formaPago;
      this.cadenaCantidad = item.cant;
      this.cadenaDescripcion = item.descripcion;
      this.cadenaPrecioUnitario = item.precioUnitario;
      this.cadenaVentasSujetas = item.ventasSujetas;
      this.cadenaVentasExentas = item.ventasExentas;
      this.cadenaVentasAfectas = item.ventasAfectas;
      var list_cant = item.cant.split("~");
      var list_desc = item.descripcion.split("~");
      var list_pu = item.precioUnitario.split("~");
      var list_vs = item.ventasSujetas.split("~");
      var list_ve = item.ventasExentas.split("~");
      var list_va = item.ventasAfectas.split("~");
      for (var i = 0; i < list_cant.length; i++) {
        var variableCant = "cant_" + (i + 1);
        var variableDesc = "descripcion_" + (i + 1);
        var variablePU = "precioUnitario_" + (i + 1);
        var variableVS = "ventasSujetas_" + (i + 1);
        var variableVE = "ventasExcentas_" + (i + 1);
        var variableVA = "ventasAfectas_" + (i + 1);
        this[variableCant] = list_cant[i];
        this[variableDesc] = list_desc[i];
        this[variablePU] = list_pu[i];
        this[variableVS] = list_vs[i];
        this[variableVE] = list_ve[i];
        this[variableVA] = list_va[i];
      }
      this.sumas = item.sumas.toFixed(2);
      this.iva = item.iva;
      this.subTotal = item.subTotal;
      this.ventaNoSujeta = item.sumaVentaNoSujeta.toFixed(2);
      this.ventasExentas = item.sumaVentasExentas.toFixed(2);
      this.ivaRetenido = item.ivaRetenido.toFixed(2);
      this.montoDolares = item.total;
      this.verNuevo = 1;
      this.verDet = 1;

      this.conversionNumero(item.total);
    },
    cadenaCant() {
      this.cadenaCantidad = "";
      if (document.getElementById("cant1").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad + document.getElementById("cant1").innerText;
      }
      if (document.getElementById("cant2").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant2").innerText;
      }
      if (document.getElementById("cant3").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant3").innerText;
      }
      if (document.getElementById("cant4").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant4").innerText;
      }
      if (document.getElementById("cant5").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant5").innerText;
      }
      if (document.getElementById("cant6").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant6").innerText;
      }
      if (document.getElementById("cant7").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant7").innerText;
      }
      if (document.getElementById("cant8").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant8").innerText;
      }
      if (document.getElementById("cant9").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant9").innerText;
      }
      if (document.getElementById("cant10").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant10").innerText;
      }
    },
    cadenaDesc() {
      this.cadenaDescripcion = "";
      if (document.getElementById("desc1").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion + document.getElementById("desc1").innerText;
      }
      if (document.getElementById("desc2").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc2").innerText;
      }
      if (document.getElementById("desc3").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc3").innerText;
      }
      if (document.getElementById("desc4").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc4").innerText;
      }
      if (document.getElementById("desc5").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc5").innerText;
      }
      if (document.getElementById("desc6").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc6").innerText;
      }
      if (document.getElementById("desc7").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc7").innerText;
      }
      if (document.getElementById("desc8").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc8").innerText;
      }
      if (document.getElementById("desc9").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc9").innerText;
      }
      if (document.getElementById("desc10").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc10").innerText;
      }
    },
    cadenaPU() {
      this.cadenaPrecioUnitario = "";
      if (document.getElementById("pu1").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario + document.getElementById("pu1").innerText;
      }
      if (document.getElementById("pu2").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu2").innerText;
      }
      if (document.getElementById("pu3").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu3").innerText;
      }
      if (document.getElementById("pu4").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu4").innerText;
      }
      if (document.getElementById("pu5").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu5").innerText;
      }
      if (document.getElementById("pu6").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu6").innerText;
      }
      if (document.getElementById("pu7").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu7").innerText;
      }
      if (document.getElementById("pu8").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu8").innerText;
      }
      if (document.getElementById("pu9").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu9").innerText;
      }
      if (document.getElementById("pu10").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu10").innerText;
      }
    },
    cadenaVS() {
      this.cadenaVentasSujetas = "";
      if (document.getElementById("vs1").innerText != "") {
        this.cadenaVentasSujetas =
          this.cadenaVentasSujetas + document.getElementById("vs1").innerText;
      }
      if (document.getElementById("vs2").innerText != "") {
        this.cadenaVentasSujetas =
          this.cadenaVentasSujetas +
          "~" +
          document.getElementById("vs2").innerText;
      }
      if (document.getElementById("vs3").innerText != "") {
        this.cadenaVentasSujetas =
          this.cadenaVentasSujetas +
          "~" +
          document.getElementById("vs3").innerText;
      }
      if (document.getElementById("vs4").innerText != "") {
        this.cadenaVentasSujetas =
          this.cadenaVentasSujetas +
          "~" +
          document.getElementById("vs4").innerText;
      }
      if (document.getElementById("vs5").innerText != "") {
        this.cadenaVentasSujetas =
          this.cadenaVentasSujetas +
          "~" +
          document.getElementById("vs5").innerText;
      }
      if (document.getElementById("vs6").innerText != "") {
        this.cadenaVentasSujetas =
          this.cadenaVentasSujetas +
          "~" +
          document.getElementById("vs6").innerText;
      }
      if (document.getElementById("vs7").innerText != "") {
        this.cadenaVentasSujetas =
          this.cadenaVentasSujetas +
          "~" +
          document.getElementById("vs7").innerText;
      }
      if (document.getElementById("vs8").innerText != "") {
        this.cadenaVentasSujetas =
          this.cadenaVentasSujetas +
          "~" +
          document.getElementById("vs8").innerText;
      }
      if (document.getElementById("vs9").innerText != "") {
        this.cadenaVentasSujetas =
          this.cadenaVentasSujetas +
          "~" +
          document.getElementById("vs9").innerText;
      }
      if (document.getElementById("vs10").innerText != "") {
        this.cadenaVentasSujetas =
          this.cadenaVentasSujetas +
          "~" +
          document.getElementById("vs10").innerText;
      }
      this.sumarVentasNoSujetas();
    },
    cadenaVE() {
      this.cadenaVentasExentas = "";
      if (document.getElementById("ve1").innerText != "") {
        this.cadenaVentasExentas =
          this.cadenaVentasExentas + document.getElementById("ve1").innerText;
      }
      if (document.getElementById("ve2").innerText != "") {
        this.cadenaVentasExentas =
          this.cadenaVentasExentas +
          "~" +
          document.getElementById("ve2").innerText;
      }
      if (document.getElementById("ve3").innerText != "") {
        this.cadenaVentasExentas =
          this.cadenaVentasExentas +
          "~" +
          document.getElementById("ve3").innerText;
      }
      if (document.getElementById("ve4").innerText != "") {
        this.cadenaVentasExentas =
          this.cadenaVentasExentas +
          "~" +
          document.getElementById("ve4").innerText;
      }
      if (document.getElementById("ve5").innerText != "") {
        this.cadenaVentasExentas =
          this.cadenaVentasExentas +
          "~" +
          document.getElementById("ve5").innerText;
      }
      if (document.getElementById("ve6").innerText != "") {
        this.cadenaVentasExentas =
          this.cadenaVentasExentas +
          "~" +
          document.getElementById("ve6").innerText;
      }
      if (document.getElementById("ve7").innerText != "") {
        this.cadenaVentasExentas =
          this.cadenaVentasExentas +
          "~" +
          document.getElementById("ve7").innerText;
      }
      if (document.getElementById("ve8").innerText != "") {
        this.cadenaVentasExentas =
          this.cadenaVentasExentas +
          "~" +
          document.getElementById("ve8").innerText;
      }
      if (document.getElementById("ve9").innerText != "") {
        this.cadenaVentasExentas =
          this.cadenaVentasExentas +
          "~" +
          document.getElementById("ve9").innerText;
      }
      if (document.getElementById("ve10").innerText != "") {
        this.cadenaVentasExentas =
          this.cadenaVentasExentas +
          "~" +
          document.getElementById("ve10").innerText;
      }
      this.sumarVentasExentas();
    },
    cadenaVA() {
      this.cadenaVentasAfectas = "";
      if (document.getElementById("va1").innerText != "") {
        this.cadenaVentasAfectas = document.getElementById("va1").innerText;
      }
      if (document.getElementById("va2").innerText != "") {
        this.cadenaVentasAfectas =
          this.cadenaVentasAfectas +
          "~" +
          document.getElementById("va2").innerText;
      }
      if (document.getElementById("va3").innerText != "") {
        this.cadenaVentasAfectas =
          this.cadenaVentasAfectas +
          "~" +
          document.getElementById("va3").innerText;
      }
      if (document.getElementById("va4").innerText != "") {
        this.cadenaVentasAfectas =
          this.cadenaVentasAfectas +
          "~" +
          document.getElementById("va4").innerText;
      }
      if (document.getElementById("va5").innerText != "") {
        this.cadenaVentasAfectas =
          this.cadenaVentasAfectas +
          "~" +
          document.getElementById("va5").innerText;
      }
      if (document.getElementById("va6").innerText != "") {
        this.cadenaVentasAfectas =
          this.cadenaVentasAfectas +
          "~" +
          document.getElementById("va6").innerText;
      }
      if (document.getElementById("va7").innerText != "") {
        this.cadenaVentasAfectas =
          this.cadenaVentasAfectas +
          "~" +
          document.getElementById("va7").innerText;
      }
      if (document.getElementById("va8").innerText != "") {
        this.cadenaVentasAfectas =
          this.cadenaVentasAfectas +
          "~" +
          document.getElementById("va8").innerText;
      }
      if (document.getElementById("va9").innerText != "") {
        this.cadenaVentasAfectas =
          this.cadenaVentasAfectas +
          "~" +
          document.getElementById("va9").innerText;
      }
      if (document.getElementById("va10").innerText != "") {
        this.cadenaVentasAfectas =
          this.cadenaVentasAfectas +
          "~" +
          document.getElementById("va10").innerText;
      }
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      axios
        .post(
          "api/FormFacturas/Crear",
          {
            idUsuario: me.$store.state.usuario.idUsuario,
            idBaseClienteFactura: me.idBaseClienteFactura,
            fechaCreacion: me.fechaCreacion,
            fecha: me.fecha,
            cliente: me.cliente,
            direccion: me.direccion,
            departamento: me.departamento,
            nit: me.nit,
            ncr: me.ncr,
            giro: me.giro,
            formaPago: me.formaPago,
            cant: me.cadenaCantidad,
            descripcion: me.cadenaDescripcion,
            precioUnitario: me.cadenaPrecioUnitario,
            ventasSujetas: me.cadenaVentasSujetas,
            ventasExentas: me.cadenaVentasExentas,
            ventasAfectas: me.cadenaVentasAfectas,
            numeroFactura: me.numeroFactura,
            sumas: me.sumas,
            iva: me.iva,
            subTotal: me.subTotal,
            ivaRetenido: me.ivaRetenido,
            sumaVentaNoSujeta: me.ventaNoSujeta,
            sumaVentasExentas: me.ventasExentas,
            total: me.montoDolares,
          },
          configuracion
        )
        .then(function (response) {
          me.overlay = false;
          me.limpiar();
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    actualizar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      axios
        .put(
          "api/FormFacturas/Actualizar",
          {
            idfactura: me.idFactura,
            idUsuario: me.idUsuario,
            idBaseClienteFactura: me.idBaseClienteFactura,
            fechaCreacion: me.fechaCreacion,
            fecha: me.fecha,
            cliente: me.cliente,
            direccion: me.direccion,
            departamento: me.departamento,
            nit: me.nit,
            ncr: me.ncr,
            giro: me.giro,
            formaPago: me.formaPago,
            cant: me.cadenaCantidad,
            descripcion: me.cadenaDescripcion,
            precioUnitario: me.cadenaPrecioUnitario,
            ventasSujetas: me.cadenaVentasSujetas,
            ventasExentas: me.cadenaVentasExentas,
            ventasAfectas: me.cadenaVentasAfectas,
            numeroFactura: me.numeroFactura,
            sumas: document.getElementById("sumas").innerText,
            iva: document.getElementById("iva").innerText,
            subTotal: document.getElementById("subTotal").innerText,
            ivaRetenido: document.getElementById("ivaRetenido").innerText,
            sumaVentaNoSujeta:
              document.getElementById("ventaNoSujeta").innerText,
            sumaVentasExentas:
              document.getElementById("ventasExentas").innerText,
            total: me.montoDolares,
          },
          configuracion
        )
        .then(function (response) {
          me.overlay = false;
          me.limpiar();
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    habilitarCuadricula() {
      if (this.banderaCuadricula) {
        $("td,th").css({
          border: "1px solid #000000",
          //"text-align": "left",
          //"font-size": "12px",
        });
      } else {
        $("td,th").css({
          border: "1px solid #ffffff",
          //"text-align": "left",
          //"font-size": "12px",
        });
      }
    },
    habilitarTitulos() {
      if (this.banderaTitulos) {
        this.correlativo = true;
        $(".textStyleTabla1").css({
          color: "#000000",
        });

        $(".textStyle").css({
          color: "#000000",
        });
      } else {
        this.correlativo = false;
        $(".textStyleTabla1").css({
          color: "#ffffff",
        });

        $(".textStyle").css({
          color: "#ffffff",
        });
      }
    },
    imprimir() {
      this.$refs.html2Pdf.generatePdf();
    },
    sumasTabla() {
      /////////////////////////////TOMA TODOS LOS DATOS DE LA COLUMNA Y HACE LOS CALCULOS
      this.sumas = 0;
      this.ventasAfectas_1 = "";
      if (
        document.getElementById("cant1").innerText != "" &&
        document.getElementById("pu1").innerText != ""
      ) {
        this.ventasAfectas_1 =
          parseFloat(document.getElementById("cant1").innerText) *
          parseFloat(document.getElementById("pu1").innerText);
      } else if (document.getElementById("va1").innerText != "") {
        this.ventasAfectas_1 = parseFloat(
          document.getElementById("va1").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.ventasAfectas_2 = "";
      if (
        document.getElementById("cant2").innerText != "" &&
        document.getElementById("pu2").innerText != ""
      ) {
        this.ventasAfectas_2 =
          parseFloat(document.getElementById("cant2").innerText) *
          parseFloat(document.getElementById("pu2").innerText);
      } else if (document.getElementById("va2").innerText != "") {
        this.ventasAfectas_2 = parseFloat(
          document.getElementById("va2").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.ventasAfectas_3 = "";
      if (
        document.getElementById("cant3").innerText != "" &&
        document.getElementById("pu3").innerText != ""
      ) {
        this.ventasAfectas_3 =
          parseFloat(document.getElementById("cant3").innerText) *
          parseFloat(document.getElementById("pu3").innerText);
      } else if (document.getElementById("va3").innerText != "") {
        this.ventasAfectas_3 = parseFloat(
          document.getElementById("va3").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.ventasAfectas_4 = "";
      if (
        document.getElementById("cant4").innerText != "" &&
        document.getElementById("pu4").innerText != ""
      ) {
        this.ventasAfectas_4 =
          parseFloat(document.getElementById("cant4").innerText) *
          parseFloat(document.getElementById("pu4").innerText);
      } else if (document.getElementById("va4").innerText != "") {
        this.ventasAfectas_4 = parseFloat(
          document.getElementById("va4").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.ventasAfectas_5 = "";
      if (
        document.getElementById("cant5").innerText != "" &&
        document.getElementById("pu5").innerText != ""
      ) {
        this.ventasAfectas_5 =
          parseFloat(document.getElementById("cant5").innerText) *
          parseFloat(document.getElementById("pu5").innerText);
      } else if (document.getElementById("va5").innerText != "") {
        this.ventasAfectas_5 = parseFloat(
          document.getElementById("va5").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.ventasAfectas_6 = "";
      if (
        document.getElementById("cant6").innerText != "" &&
        document.getElementById("pu6").innerText != ""
      ) {
        this.ventasAfectas_6 =
          parseFloat(document.getElementById("cant6").innerText) *
          parseFloat(document.getElementById("pu6").innerText);
      } else if (document.getElementById("va6").innerText != "") {
        this.ventasAfectas_6 = parseFloat(
          document.getElementById("va6").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.ventasAfectas_7 = "";
      if (
        document.getElementById("cant7").innerText != "" &&
        document.getElementById("pu7").innerText != ""
      ) {
        this.ventasAfectas_7 =
          parseFloat(document.getElementById("cant7").innerText) *
          parseFloat(document.getElementById("pu7").innerText);
      } else if (document.getElementById("va7").innerText != "") {
        this.ventasAfectas_7 = parseFloat(
          document.getElementById("va7").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.ventasAfectas_8 = "";
      if (
        document.getElementById("cant8").innerText != "" &&
        document.getElementById("pu8").innerText != ""
      ) {
        this.ventasAfectas_8 =
          parseFloat(document.getElementById("cant8").innerText) *
          parseFloat(document.getElementById("pu8").innerText);
      } else if (document.getElementById("va8").innerText != "") {
        this.ventasAfectas_8 = parseFloat(
          document.getElementById("va8").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.ventasAfectas_9 = "";
      if (
        document.getElementById("cant9").innerText != "" &&
        document.getElementById("pu9").innerText != ""
      ) {
        this.ventasAfectas_9 =
          parseFloat(document.getElementById("cant9").innerText) *
          parseFloat(document.getElementById("pu9").innerText);
      } else if (document.getElementById("va9").innerText != "") {
        this.ventasAfectas_9 = parseFloat(
          document.getElementById("va9").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.ventasAfectas_10 = "";
      if (
        document.getElementById("cant10").innerText != "" &&
        document.getElementById("pu10").innerText != ""
      ) {
        this.ventasAfectas_10 =
          parseFloat(document.getElementById("cant10").innerText) *
          parseFloat(document.getElementById("pu10").innerText);
      } else if (document.getElementById("va10").innerText != "") {
        this.ventasAfectas_10 = parseFloat(
          document.getElementById("va10").innerText
        );
      }
      ///////////////////ESTOS IF SON PARA EVITAR PONER TODOS LOS CEROS Y SE PUEDAN HACER LOS CALCULOS
      if (this.ventasAfectas_1 != "") {
        this.sumas = this.sumas + parseFloat(this.ventasAfectas_1);
      }
      if (this.ventasAfectas_2 != "") {
        this.sumas = this.sumas + parseFloat(this.ventasAfectas_2);
      }
      if (this.ventasAfectas_3 != "") {
        this.sumas = this.sumas + parseFloat(this.ventasAfectas_3);
      }
      if (this.ventasAfectas_4 != "") {
        this.sumas = this.sumas + parseFloat(this.ventasAfectas_4);
      }
      if (this.ventasAfectas_5 != "") {
        this.sumas = this.sumas + parseFloat(this.ventasAfectas_5);
      }
      if (this.ventasAfectas_6 != "") {
        this.sumas = this.sumas + parseFloat(this.ventasAfectas_6);
      }
      if (this.ventasAfectas_7 != "") {
        this.sumas = this.sumas + parseFloat(this.ventasAfectas_7);
      }
      if (this.ventasAfectas_8 != "") {
        this.sumas = this.sumas + parseFloat(this.ventasAfectas_8);
      }
      if (this.ventasAfectas_9 != "") {
        this.sumas = this.sumas + parseFloat(this.ventasAfectas_9);
      }
      if (this.ventasAfectas_10 != "") {
        this.sumas = this.sumas + parseFloat(this.ventasAfectas_10);
      }
      this.sumas.toFixed(2);
      this.ivaTabla();
      this.cadenaVA();
    },
    ivaTabla() {
      //this.iva = 0;
      this.iva = document.getElementById("iva").innerHTML;
      this.iva = (this.sumas * 0.13).toFixed(2);
      this.iva = parseFloat(this.iva);
      this.subTotalTabla();
    },
    subTotalTabla() {
      this.subTotal = (parseFloat(this.sumas) + parseFloat(this.iva)).toFixed(
        2
      );

      this.ivaRetenidoTabla();
    },
    ivaRetenidoTabla() {
      if (this.es_uno_porciento) {
        if (this.sumas > 100) {
          this.ivaRetenido = (parseFloat(this.sumas) * 0.01).toFixed(2);
        } else {
          this.ivaRetenido = 0;
        }
      }

      this.totaltabla();
    },
    sumarVentasExentas() {
      this.ventasExentas = 0;
      this.ventasExcentas_1 = "";
      if (document.getElementById("ve1").innerText != "") {
        this.ventasExcentas_1 += parseFloat(
          document.getElementById("ve1").innerText
        );
      } else if (document.getElementById("ve1").innerText != "") {
        this.ventasExcentas_1 = parseFloat(
          document.getElementById("ve1").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasExcentas_2 = "";
      if (document.getElementById("ve2").innerText != "") {
        this.ventasExcentas_2 += parseFloat(
          document.getElementById("ve2").innerText
        );
      } else if (document.getElementById("ve2").innerText != "") {
        this.ventasExcentas_2 = parseFloat(
          document.getElementById("ve2").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasExcentas_3 = "";
      if (document.getElementById("ve3").innerText != "") {
        this.ventasExcentas_3 += parseFloat(
          document.getElementById("ve3").innerText
        );
      } else if (document.getElementById("ve3").innerText != "") {
        this.ventasExcentas_3 = parseFloat(
          document.getElementById("ve3").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasExcentas_4 = "";
      if (document.getElementById("ve4").innerText != "") {
        this.ventasExcentas_4 += parseFloat(
          document.getElementById("ve4").innerText
        );
      } else if (document.getElementById("ve4").innerText != "") {
        this.ventasExcentas_4 = parseFloat(
          document.getElementById("ve4").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasExcentas_5 = "";
      if (document.getElementById("ve5").innerText != "") {
        this.ventasExcentas_5 += parseFloat(
          document.getElementById("ve5").innerText
        );
      } else if (document.getElementById("ve5").innerText != "") {
        this.ventasExcentas_5 = parseFloat(
          document.getElementById("ve5").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasExcentas_6 = "";
      if (document.getElementById("ve6").innerText != "") {
        this.ventasExcentas_6 += parseFloat(
          document.getElementById("ve6").innerText
        );
      } else if (document.getElementById("ve6").innerText != "") {
        this.ventasExcentas_6 = parseFloat(
          document.getElementById("ve6").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasExcentas_7 = "";
      if (document.getElementById("ve7").innerText != "") {
        this.ventasExcentas_7 += parseFloat(
          document.getElementById("ve7").innerText
        );
      } else if (document.getElementById("ve7").innerText != "") {
        this.ventasExcentas_7 = parseFloat(
          document.getElementById("ve7").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasExcentas_8 = "";
      if (document.getElementById("ve8").innerText != "") {
        this.ventasExcentas_8 += parseFloat(
          document.getElementById("ve8").innerText
        );
      } else if (document.getElementById("ve8").innerText != "") {
        this.ventasExcentas_8 = parseFloat(
          document.getElementById("ve8").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasExcentas_9 = "";
      if (document.getElementById("ve9").innerText != "") {
        this.ventasExcentas_9 += parseFloat(
          document.getElementById("ve9").innerText
        );
      } else if (document.getElementById("ve9").innerText != "") {
        this.ventasExcentas_9 = parseFloat(
          document.getElementById("ve9").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasExcentas_10 = "";
      if (document.getElementById("ve10").innerText != "") {
        this.ventasExcentas_10 += parseFloat(
          document.getElementById("ve10").innerText
        );
      } else if (document.getElementById("ve10").innerText != "") {
        this.ventasExcentas_10 = parseFloat(
          document.getElementById("ve10").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      if (this.ventasExcentas_1 != "") {
        this.ventasExentas =
          this.ventasExentas + parseFloat(this.ventasExcentas_1);
      }
      if (this.ventasExcentas_2 != "") {
        this.ventasExentas =
          this.ventasExentas + parseFloat(this.ventasExcentas_2);
      }
      if (this.ventasExcentas_3 != "") {
        this.ventasExentas =
          this.ventasExentas + parseFloat(this.ventasExcentas_3);
      }
      if (this.ventasExcentas_4 != "") {
        this.ventasExentas =
          this.ventasExentas + parseFloat(this.ventasExcentas_4);
      }
      if (this.ventasExcentas_5 != "") {
        this.ventasExentas =
          this.ventasExentas + parseFloat(this.ventasExcentas_5);
      }
      if (this.ventasExcentas_6 != "") {
        this.ventasExentas =
          this.ventasExentas + parseFloat(this.ventasExcentas_6);
      }
      if (this.ventasExcentas_7 != "") {
        this.ventasExentas =
          this.ventasExentas + parseFloat(this.ventasExcentas_7);
      }
      if (this.ventasExcentas_8 != "") {
        this.ventasExentas =
          this.ventasExentas + parseFloat(this.ventasExcentas_8);
      }
      if (this.ventasExcentas_9 != "") {
        this.ventasExentas =
          this.ventasExentas + parseFloat(this.ventasExcentas_9);
      }
      if (this.ventasExcentas_10 != "") {
        this.ventasExentas =
          this.ventasExentas + parseFloat(this.ventasExcentas_10);
      }
    },
    sumarVentasNoSujetas() {
      this.ventaNoSujeta = 0;
      this.ventasSujetas_1 = "";
      if (document.getElementById("vs1").innerText != "") {
        this.ventasSujetas_1 += parseFloat(
          document.getElementById("vs1").innerText
        );
      } else if (document.getElementById("vs1").innerText != "") {
        this.ventasSujetas_1 = parseFloat(
          document.getElementById("vs1").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasSujetas_2 = "";
      if (document.getElementById("vs2").innerText != "") {
        this.ventasSujetas_2 += parseFloat(
          document.getElementById("vs2").innerText
        );
      } else if (document.getElementById("vs2").innerText != "") {
        this.ventasSujetas_2 = parseFloat(
          document.getElementById("vs2").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasSujetas_3 = "";
      if (document.getElementById("vs3").innerText != "") {
        this.ventasSujetas_3 += parseFloat(
          document.getElementById("vs3").innerText
        );
      } else if (document.getElementById("vs3").innerText != "") {
        this.ventasSujetas_3 = parseFloat(
          document.getElementById("vs3").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasSujetas_4 = "";
      if (document.getElementById("vs4").innerText != "") {
        this.ventasSujetas_4 += parseFloat(
          document.getElementById("vs4").innerText
        );
      } else if (document.getElementById("vs4").innerText != "") {
        this.ventasSujetas_4 = parseFloat(
          document.getElementById("vs4").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasSujetas_5 = "";
      if (document.getElementById("vs5").innerText != "") {
        this.ventasSujetas_5 += parseFloat(
          document.getElementById("vs5").innerText
        );
      } else if (document.getElementById("vs5").innerText != "") {
        this.ventasSujetas_5 = parseFloat(
          document.getElementById("vs5").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasSujetas_6 = "";
      if (document.getElementById("vs6").innerText != "") {
        this.ventasSujetas_6 += parseFloat(
          document.getElementById("vs6").innerText
        );
      } else if (document.getElementById("vs6").innerText != "") {
        this.ventasSujetas_6 = parseFloat(
          document.getElementById("vs6").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasSujetas_7 = "";
      if (document.getElementById("vs7").innerText != "") {
        this.ventasSujetas_7 += parseFloat(
          document.getElementById("vs7").innerText
        );
      } else if (document.getElementById("vs7").innerText != "") {
        this.ventasSujetas_7 = parseFloat(
          document.getElementById("vs7").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasSujetas_8 = "";
      if (document.getElementById("vs8").innerText != "") {
        this.ventasSujetas_8 += parseFloat(
          document.getElementById("vs8").innerText
        );
      } else if (document.getElementById("vs8").innerText != "") {
        this.ventasSujetas_8 = parseFloat(
          document.getElementById("vs8").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasSujetas_9 = "";
      if (document.getElementById("vs9").innerText != "") {
        this.ventasSujetas_9 += parseFloat(
          document.getElementById("vs9").innerText
        );
      } else if (document.getElementById("vs9").innerText != "") {
        this.ventasSujetas_9 = parseFloat(
          document.getElementById("vs9").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      this.ventasSujetas_10 = "";
      if (document.getElementById("vs10").innerText != "") {
        this.ventasSujetas_10 += parseFloat(
          document.getElementById("vs10").innerText
        );
      } else if (document.getElementById("vs10").innerText != "") {
        this.ventasSujetas_10 = parseFloat(
          document.getElementById("vs10").innerText
        );
      }
      //////////////////////////////////////////////////////////////
      if (this.ventasSujetas_1 != "") {
        this.ventaNoSujeta =
          this.ventaNoSujeta + parseFloat(this.ventasSujetas_1);
      }
      if (this.ventasSujetas_2 != "") {
        this.ventaNoSujeta =
          this.ventaNoSujeta + parseFloat(this.ventasSujetas_2);
      }
      if (this.ventasSujetas_3 != "") {
        this.ventaNoSujeta =
          this.ventaNoSujeta + parseFloat(this.ventasSujetas_3);
      }
      if (this.ventasSujetas_4 != "") {
        this.ventaNoSujeta =
          this.ventaNoSujeta + parseFloat(this.ventasSujetas_4);
      }
      if (this.ventasSujetas_5 != "") {
        this.ventaNoSujeta =
          this.ventaNoSujeta + parseFloat(this.ventasSujetas_5);
      }
      if (this.ventasSujetas_6 != "") {
        this.ventaNoSujeta =
          this.ventaNoSujeta + parseFloat(this.ventasSujetas_6);
      }
      if (this.ventasSujetas_7 != "") {
        this.ventaNoSujeta =
          this.ventaNoSujeta + parseFloat(this.ventasSujetas_7);
      }
      if (this.ventasSujetas_8 != "") {
        this.ventaNoSujeta =
          this.ventaNoSujeta + parseFloat(this.ventasSujetas_8);
      }
      if (this.ventasSujetas_9 != "") {
        this.ventaNoSujeta =
          this.ventaNoSujeta + parseFloat(this.ventasSujetas_9);
      }
      if (this.ventasSujetas_10 != "") {
        this.ventaNoSujeta =
          this.ventaNoSujeta + parseFloat(this.ventasSujetas_10);
      }
    },
    totaltabla() {
      this.montoDolares = (
        parseFloat(this.subTotal) - parseFloat(this.ivaRetenido)
      ).toFixed(2);
    },
    limpiar() {
      this.verNuevo = 0;
      this.verDet = 0;
      this.nombreClienteItem = "";
      this.items = [];
      this.idFactura = "";
      this.idUsuario = "";
      this.idBaseClienteFactura = "";
      this.fechaCreacion = "";
      this.numeroFactura = "***";
      this.fecha = "Fecha";
      this.cliente = "***";
      this.direccion = "***";
      this.departamento = "***";
      this.giro = "***";
      this.nit = "***";
      this.ncr = "***";
      this.formaPago = "***";
      this.banderaCuadricula = true;
      this.banderaTitulos = true;
      this.cadenaCantidad = "";
      this.cant_1 = "";
      this.cant_2 = "";
      this.cant_3 = "";
      this.cant_4 = "";
      this.cant_5 = "";
      this.cant_6 = "";
      this.cant_7 = "";
      this.cant_8 = "";
      this.cant_9 = "";
      this.cant_10 = "";
      this.cadenaDescripcion = "";
      this.descripcion_1 = "";
      this.descripcion_2 = "";
      this.descripcion_3 = "";
      this.descripcion_4 = "";
      this.descripcion_5 = "";
      this.descripcion_6 = "";
      this.descripcion_7 = "";
      this.descripcion_8 = "";
      this.descripcion_9 = "";
      this.descripcion_10 = "";
      this.cadenaPrecioUnitario = "";
      this.precioUnitario_1 = "";
      this.precioUnitario_2 = "";
      this.precioUnitario_3 = "";
      this.precioUnitario_4 = "";
      this.precioUnitario_5 = "";
      this.precioUnitario_6 = "";
      this.precioUnitario_7 = "";
      this.precioUnitario_8 = "";
      this.precioUnitario_9 = "";
      this.precioUnitario_10 = "";
      this.cadenaVentasSujetas = "";
      this.ventasSujetas_1 = "";
      this.ventasSujetas_2 = "";
      this.ventasSujetas_3 = "";
      this.ventasSujetas_4 = "";
      this.ventasSujetas_5 = "";
      (this.ventasSujetas_6 = ""), (this.ventasSujetas_7 = "");
      this.ventasSujetas_8 = "";
      this.ventasSujetas_9 = "";
      this.ventasSujetas_10 = "";
      this.cadenaVentasExentas = "";
      this.ventasExcentas_1 = "";
      this.ventasExcentas_2 = "";
      this.ventasExcentas_3 = "";
      this.ventasExcentas_4 = "";
      this.ventasExcentas_5 = "";
      this.ventasExcentas_6 = "";
      this.ventasExcentas_7 = "";
      this.ventasExcentas_8 = "";
      this.ventasExcentas_9 = "";
      this.ventasExcentas_10 = "";
      this.cadenaVentasAfectas = "";
      this.ventasAfectas_1 = "";
      this.ventasAfectas_2 = "";
      this.ventasAfectas_3 = "";
      this.ventasAfectas_4 = "";
      this.ventasAfectas_5 = "";
      this.ventasAfectas_6 = "";
      this.ventasAfectas_7 = "";
      this.ventasAfectas_8 = "";
      this.ventasAfectas_9 = "";
      this.ventasAfectas_10 = "";
      this.sumas = 0;
      this.iva = 0;
      this.subTotal = 0;
      this.ivaRetenido = 0;
      this.ventasExentas = 0;
      this.ventaNoSujeta = 0;
      this.montoDolares = 0;
      this.cantidadLetras = "";
      this.es_uno_porciento = false;
    },
    /////////////////////////////////////////////////////////////////////////////////////////
    conversionNumero(item) {
      //this.montoDolares = document.getElementById("total").innerHTML;
      if (!item) {
        item = this.montoDolares;
      }

      var lettet = this.numeroALetras(item, {
        plural: "dólares estadounidenses",
        singular: "dólar estadounidense",
        centPlural: "centavos",
        centSingular: "centavo",
      });

      const posicion = lettet.indexOf("dólares");
      let tempCantidadLetras = "";
      if (posicion !== -1) {
        tempCantidadLetras = lettet.substring(0, posicion).trim();
      }

      const decimales = this.montoDolares - Math.floor(this.montoDolares);
      tempCantidadLetras += ` ${(decimales * 100).toFixed(0)}/100`;

      this.cantidadLetras = tempCantidadLetras;
    },
    Unidades(num) {
      switch (num) {
        case 1:
          return "UN";
        case 2:
          return "DOS";
        case 3:
          return "TRES";
        case 4:
          return "CUATRO";
        case 5:
          return "CINCO";
        case 6:
          return "SEIS";
        case 7:
          return "SIETE";
        case 8:
          return "OCHO";
        case 9:
          return "NUEVE";
      }

      return "";
    },
    Decenas(num) {
      let decena = Math.floor(num / 10);
      let unidad = num - decena * 10;

      switch (decena) {
        case 1:
          switch (unidad) {
            case 0:
              return "DIEZ";
            case 1:
              return "ONCE";
            case 2:
              return "DOCE";
            case 3:
              return "TRECE";
            case 4:
              return "CATORCE";
            case 5:
              return "QUINCE";
            default:
              return "DIECI" + this.Unidades(unidad);
          }
        case 2:
          switch (unidad) {
            case 0:
              return "VEINTE";
            default:
              return "VEINTI" + this.Unidades(unidad);
          }
        case 3:
          return this.DecenasY("TREINTA", unidad);
        case 4:
          return this.DecenasY("CUARENTA", unidad);
        case 5:
          return this.DecenasY("CINCUENTA", unidad);
        case 6:
          return this.DecenasY("SESENTA", unidad);
        case 7:
          return this.DecenasY("SETENTA", unidad);
        case 8:
          return this.DecenasY("OCHENTA", unidad);
        case 9:
          return this.DecenasY("NOVENTA", unidad);
        case 0:
          return this.Unidades(unidad);
      }
    },
    DecenasY(strSin, numUnidades) {
      if (numUnidades > 0) return strSin + " Y " + this.Unidades(numUnidades);

      return strSin;
    },
    Centenas(num) {
      let centenas = Math.floor(num / 100);
      let decenas = num - centenas * 100;

      switch (centenas) {
        case 1:
          if (decenas > 0) return "CIENTO " + this.Decenas(decenas);
          return "CIEN";
        case 2:
          return "DOSCIENTOS " + this.Decenas(decenas);
        case 3:
          return "TRESCIENTOS " + this.Decenas(decenas);
        case 4:
          return "CUATROCIENTOS " + this.Decenas(decenas);
        case 5:
          return "QUINIENTOS " + this.Decenas(decenas);
        case 6:
          return "SEISCIENTOS " + this.Decenas(decenas);
        case 7:
          return "SETECIENTOS " + this.Decenas(decenas);
        case 8:
          return "OCHOCIENTOS " + this.Decenas(decenas);
        case 9:
          return "NOVECIENTOS " + this.Decenas(decenas);
      }

      return this.Decenas(decenas);
    },
    Seccion(num, divisor, strSingular, strPlural) {
      let cientos = Math.floor(num / divisor);
      let resto = num - cientos * divisor;

      let letras = "";

      if (cientos > 0)
        if (cientos > 1) letras = this.Centenas(cientos) + " " + strPlural;
        else letras = strSingular;

      if (resto > 0) letras += "";

      return letras;
    },
    Miles(num) {
      let divisor = 1000;
      let cientos = Math.floor(num / divisor);
      let resto = num - cientos * divisor;

      let strMiles = this.Seccion(num, divisor, "UN MIL", "MIL");
      let strCentenas = this.Centenas(resto);

      if (strMiles == "") return strCentenas;

      return strMiles + " " + strCentenas;
    },
    millon(num, singular) {
      var letraMillon = "";
      if (singular == true) letraMillon = "UN MILLON";
      else letraMillon = "MILLONES";
      if (num % 1000000 == 0) letraMillon = letraMillon + " DE";
      return letraMillon;
    },
    millones(num) {
      let divisor = 1000000;
      let cientos = Math.floor(num / divisor);
      let resto = num - cientos * divisor;

      let strMillones = this.Seccion(
        num,
        divisor,
        this.millon(num, true),
        this.millon(num, false)
      );
      let strMiles = this.Miles(resto);

      if (strMillones == "") return strMiles;

      return strMillones + " " + strMiles;
    },
    numeroALetras(num, currency) {
      let me = this;
      currency = currency || {};
      let data = {
        numero: num,
        enteros: Math.floor(num),
        centavos: Math.round(num * 100) - Math.floor(num) * 100,
        letrasCentavos: "",
        letrasMonedaPlural: currency.plural || "PESOS CHILENOS", //'PESOS', 'Dólares', 'Bolívares', 'etcs'
        letrasMonedaSingular: currency.singular || "PESO CHILENO", //'PESO', 'Dólar', 'Bolivar', 'etc'
        letrasMonedaCentavoPlural:
          currency.centPlural || "CHIQUI PESOS CHILENOS",
        letrasMonedaCentavoSingular:
          currency.centSingular || "CHIQUI PESO CHILENO",
      };

      if (data.centavos > 0) {
        data.letrasCentavos =
          "CON " +
          (function () {
            if (data.centavos == 1)
              return (
                me.millones(data.centavos) +
                " " +
                data.letrasMonedaCentavoSingular
              );
            else
              return (
                me.millones(data.centavos) +
                " " +
                data.letrasMonedaCentavoPlural
              );
          })();
      }

      if (data.enteros == 0)
        return "CERO " + data.letrasMonedaPlural + " " + data.letrasCentavos;
      if (data.enteros == 1)
        return (
          me.millones(data.enteros) +
          " " +
          data.letrasMonedaSingular +
          " " +
          data.letrasCentavos
        );
      else
        return (
          me.millones(data.enteros) +
          " " +
          data.letrasMonedaPlural +
          " " +
          data.letrasCentavos
        );
    },
    generarObjetoExcel() {
      let me = this;
      me.exportData = [];

      for (var i = 0; i < me.facturas.length; i++) {
        //console.log('dato', me.facturas[i]);
        me.exportData.push({
          "Numero factura": me.facturas[i].numeroFactura,
          "Fecha creacion": me.facturas[i].fechaCreacion,
          Fecha: me.facturas[i].fecha,
          Cliente: me.facturas[i].cliente,
          Direccion: me.facturas[i].direccion,
          Departamento: me.facturas[i].departamento,
          NIT: me.facturas[i].nit,
          "N.C.R.": me.facturas[i].ncr,
          Giro: me.facturas[i].giro,
          "Forma de pago": me.facturas[i].formaPago,
          Sumas: me.facturas[i].sumas,
          IVA: me.facturas[i].iva,
          "Sub-Total": me.facturas[i].subTotal,
          "IVA Retenido": me.facturas[i].ivaRetenido,
          Total: me.facturas[i].total,
        });
      }
      me.generarExcel();
    },
    generarExcel() {
      let me = this;
      let data = XLSX.utils.json_to_sheet(me.exportData);
      const workbook = XLSX.utils.book_new();
      const filename = "Facturas";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
      me.limpiar();
    },
  },
};
</script>

<style scoped>
.some-style >>> .v-input__slot::before {
  border-style: none !important;
}
.some-style {
  margin-left: 0px;
}
.textStyle {
  padding-left: 0px;
  padding-bottom: 0px;
  font-weight: bold;
  color: rgb(0, 0, 0);
}
.textStyleTabla1 {
  padding-right: 4px;
  color: rgb(0, 0, 0);
}
.paddingText {
  padding-left: 0px;
  padding-right: 0px;
}
table {
  width: 100%;
  table-layout: fixed;
}
td,
th {
  border: 1px solid #000000;
  text-align: center;
  font-size: 12px;
}
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
.styleText {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: bold;
  margin-right: 13px;
}
.styleText-cant {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: bold;
  margin-right: 0px;
  padding-left: 8px;
}
</style>
